// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as NoAccess$LiveRoom from "./NoAccess.bs.js";
import * as SvgImages$LiveRoom from "../../assets/img/SvgImages.bs.js";
import * as SecretLoader$LiveRoom from "./SecretLoader.bs.js";
import * as Translations$LiveRoom from "../../../../translations/Translations.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Button from "@sothebys/sterling/button";

var logoAnimation = Curry._1(Css.style, {
      hd: Css.animationDuration({
            NAME: "ms",
            VAL: 1000
          }),
      tl: {
        hd: Css.animationTimingFunction("ease"),
        tl: {
          hd: Css.animationName(Curry._1(Css.keyframes, {
                    hd: [
                      0,
                      {
                        hd: Css.opacity(0.0),
                        tl: /* [] */0
                      }
                    ],
                    tl: {
                      hd: [
                        100,
                        {
                          hd: Css.opacity(1.0),
                          tl: /* [] */0
                        }
                      ],
                      tl: /* [] */0
                    }
                  })),
          tl: /* [] */0
        }
      }
    });

function SecretContainer$Header(props) {
  var loading = props.loading;
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.width(Css.pct(100)),
                          tl: {
                            hd: Css.height(Css.px(80)),
                            tl: {
                              hd: Css.position("absolute"),
                              tl: {
                                hd: Css.top("zero"),
                                tl: {
                                  hd: Css.left("zero"),
                                  tl: {
                                    hd: Css.display("flex"),
                                    tl: {
                                      hd: Css.justifyContent("center"),
                                      tl: {
                                        hd: Css.alignItems("center"),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: loading ? Curry._1(Css.style, {
                              hd: Css.backgroundColor("transparent"),
                              tl: /* [] */0
                            }) : Curry._1(Css.style, {
                              hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                              tl: {
                                hd: Css.boxShadow(Css_Legacy_Core.Shadow.box(Css.px(0), Css.px(0), Css.px(10), Css.px(0), undefined, {
                                          NAME: "rgba",
                                          VAL: [
                                            0,
                                            0,
                                            0,
                                            {
                                              NAME: "num",
                                              VAL: 0.1
                                            }
                                          ]
                                        })),
                                tl: /* [] */0
                              }
                            }),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement("div", {
                  className: logoAnimation
                }, React.createElement(SvgImages$LiveRoom.SothebysLogo.make, {})), loading ? null : React.createElement(Button.Button, {
                    onClick: (function (param) {
                        window.location = "https://www.sothebys.com?locale=" + Translations$LiveRoom.languageToJs(Translations$LiveRoom.getLanguage(undefined)) + "";
                      }),
                    className: Curry._1(Css.style, {
                          hd: Css.position("absolute"),
                          tl: {
                            hd: Css.right(Css.px(24)),
                            tl: /* [] */0
                          }
                        }),
                    buttonStyle: "tertiary",
                    size: "largeIcon",
                    children: React.createElement(SterlingIcons$LiveRoom.Collection.CloseRegular24.make, {})
                  }));
}

var Header = {
  logoAnimation: logoAnimation,
  make: SecretContainer$Header
};

function SecretContainer(props) {
  var state = props.state;
  var loginDelay = React.useRef(undefined);
  React.useEffect((function () {
          if (state !== 0) {
            
          } else {
            loginDelay.current = Caml_option.some(setTimeout((function (param) {
                        AuthTokenHook$LiveRoom.triggerLogin(window.location.href);
                      }), 500));
          }
          return (function (param) {
                    Belt_Option.map(loginDelay.current, (function (id) {
                            clearTimeout(id);
                          }));
                  });
        }), [state]);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("fixed"),
                    tl: {
                      hd: Css.width(Css.pct(100)),
                      tl: {
                        hd: Css.height(Css.pct(100)),
                        tl: {
                          hd: Css.top("zero"),
                          tl: {
                            hd: Css.left("zero"),
                            tl: {
                              hd: Css.zIndex(StyleConstants$LiveRoom.modalOnTopZIndex),
                              tl: {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.flexDirection("column"),
                                  tl: {
                                    hd: Css.justifyContent("center"),
                                    tl: {
                                      hd: Css.alignItems("center"),
                                      tl: {
                                        hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement(SecretContainer$Header, {
                  loading: state === /* Login */0
                }), React.createElement("div", {
                  className: SecretLoader$LiveRoom.Animations.fadeIn
                }, state !== 1 ? null : React.createElement(NoAccess$LiveRoom.make, {})), state !== 0 ? null : React.createElement(SecretLoader$LiveRoom.make, {
                    loading: true
                  }));
}

var make = SecretContainer;

export {
  Header ,
  make ,
}
/* logoAnimation Not a pure module */
